import React from "react";
import { Eye, User, ScanLine } from "lucide-react";

function Seg({ active, onClick, children, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 13px", cursor: "pointer",
        fontSize: 11, letterSpacing: "0.08em", textTransform: "uppercase", border: "none",
        background: active ? "linear-gradient(180deg,#f2c85b,#c9a24b)" : "transparent",
        color: active ? "#10120f" : "#c9a24b", transition: "all 0.2s ease",
      }}
    >
      {children}
    </button>
  );
}

export default function ViewControls({ viewMode, onToggleView, xray, onToggleXray, scrub, onScrub, isObserver }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, rowGap: 8, flexWrap: "wrap", pointerEvents: "auto" }}>
      <div className="hud-panel" style={{ borderRadius: 999, overflow: "hidden", display: "flex", padding: 3 }}>
        <Seg active={viewMode === "first"} onClick={() => onToggleView("first")} testId="view-first-person-button">
          <User size={13} /> Immersive
        </Seg>
        <Seg active={viewMode === "third"} onClick={() => onToggleView("third")} testId="view-third-person-button">
          <Eye size={13} /> Universal
        </Seg>
      </div>

      {viewMode === "third" && (
        <button
          data-testid="xray-toggle-button"
          onClick={onToggleXray}
          className="hud-panel"
          style={{
            display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 13px", borderRadius: 999,
            cursor: "pointer", fontSize: 11, letterSpacing: "0.08em", textTransform: "uppercase",
            color: xray ? "#4cd07a" : "#c9a24b", borderColor: xray ? "rgba(76,208,122,0.5)" : "rgba(201,162,75,0.28)",
          }}
        >
          <ScanLine size={14} /> X-Ray {xray ? "On" : "Off"}
        </button>
      )}

      {viewMode === "third" && (
        <div className="hud-panel" style={{ display: "flex", alignItems: "center", gap: 9, padding: "7px 14px", borderRadius: 999 }}>
          <span style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: "#4cd07a" }}>Egress Vector</span>
          <input
            data-testid="egress-scrub-slider"
            type="range" min="0" max="84" value={scrub}
            onChange={(e) => onScrub(Number(e.target.value))}
            style={{ width: 120, accentColor: "#4cd07a" }}
          />
          <span className="font-mono-tel" style={{ fontSize: 11, color: "#4cd07a", minWidth: 42 }}>Fl {scrub}</span>
        </div>
      )}
    </div>
  );
}
